import axios from 'axios'
export default {
	namespaced: true,
	state: {
		resultados: []
	},
	getters: {
		resultados (state) {
			return state.resultados
		}
	},
	mutations: {
		SET_RESULTADOS (state, payload) {
			state.resultados = payload
		}
	},
	actions: {
		buscar (context, payload) {
			axios.post('redaccion/php/api/buscarNoticias.php', payload)
				.then(res => {
					context.commit('SET_RESULTADOS', res.data)
				})
				.catch(e => {
					console.error(e)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/redaccion/vue/store.js